// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".VueTables .table>tbody>tr>td{vertical-align:top}.addon-cancel-btn{margin:6px 0}.addon-cancel-btn,.subscription-cancel-btn{text-decoration:none!important}", ""]);
// Exports
module.exports = exports;
